import { createModel } from 'xstate/lib/model';

import baseEvents from 'common/bento/config/baseEvents';
import { AddressSchema } from 'features/Onboarding/components/AddressForm/addressSchema';

import { GetCapitalDepositQuestionsQuery } from '../graphql/queries/getCapitalDepositQuestions.gql';
import { CompanyLegalInfoSchema } from '../libs/companyLegalInfoSchema';
import { HasPartnerSchema } from '../libs/hasPartnerSchema';
import { PartnerNameSchema } from '../libs/partnerNameSchema';
import { SameAddressSchema } from '../libs/sameAddressSchema';
import { CapitalInfoData } from '../pages/CapitalInfo/CapitalInfo';

export type CapitalDepositQuestionsModuleData = {
  data: GetCapitalDepositQuestionsQuery & {
    viewer: {
      company: {
        capitalDeposit: NonNullable<
          GetCapitalDepositQuestionsQuery['viewer']['company']['capitalDeposit']
        >;
      };
    };
  };
  isMandatee: boolean;
};

const context = {
  getModuleData: (() => {
    throw new Error('NOT_IMPLEMENTED');
  }) as () => CapitalDepositQuestionsModuleData,
};

export type Context = typeof context;

const model = createModel(
  context,

  {
    events: {
      ...baseEvents,
      SUBMIT_CAPITAL_DEPOSIT_QUESTIONS: () => ({}),
      SUBMIT_CAPITAL_INFO: (data: CapitalInfoData) => ({ data }),
      SUBMIT_COMPANY_ADDRESS: (data: AddressSchema) => ({ data }),
      SUBMIT_COMPANY_LEGAL_INFO: (data: CompanyLegalInfoSchema) => ({
        data,
      }),
      SUBMIT_HAS_PARTNER: (data: HasPartnerSchema) => ({ data }),
      SUBMIT_PARTNER_NAME: (data: PartnerNameSchema) => ({ data }),
      SUBMIT_SAME_ADDRESS: (data: SameAddressSchema) => ({ data }),
    },
  },
);

export type Model = typeof model;

export default model;
